var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusMessage),expression:"statusMessage"}],staticClass:"mt-2 pl-0.5 text-xs text-left",class:{ 'text-green-600': _vm.isSuccess, 'text-red-600': _vm.isError }},[_vm._v("\n  "+_vm._s(_vm.statusMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }